import {createReducer, on} from "@ngrx/store";
import * as FlyingFleetsActions from './flying-fleets.actions';
import {FlyingFleet} from "../../models/FlyingFleet";
export const FlyingFleetsFeatureKey = 'flyingFleet';
export const   FlyingFleetsInitialState: FlyingFleet = null;
export const FlyingFleetsReducer = createReducer<FlyingFleet | null>(
    FlyingFleetsInitialState,
  on(FlyingFleetsActions.update, (_state, { flyingFleet }) => flyingFleet),
);
